import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../auth/firebase-config/firebase';
import { url } from '../ConstUrl/Url';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [firebaseUser, setFirebaseUser] = useState(null);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('userData')) || null);
    const [loading, setLoading] = useState(true);

    const refreshUserData = async (identifier) => {
        if (!identifier) return;
        try {
            const response = await fetch(`${url}/api/user-data/${encodeURIComponent(identifier)}`);
            if (response.ok) {
                const data = await response.json();
                setUserData(data);
                localStorage.setItem('userData', JSON.stringify(data));
                window.dispatchEvent(new Event('userDataUpdated'));
            }
        } catch (error) {
            console.error('Error refreshing user data:', error);
        }
    };

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            setFirebaseUser(user);
            if (user) {
                const identifier = user.email || user.phoneNumber;
                await refreshUserData(identifier);
            } else {
                setUserData(null);
                localStorage.removeItem('userData');
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    // Also listen for manual updates (e.g. from Boost dialogs)
    useEffect(() => {
        const handleUpdate = () => {
            const stored = JSON.parse(localStorage.getItem('userData'));
            if (stored) setUserData(stored);
        };
        window.addEventListener('userDataUpdated', handleUpdate);
        return () => window.removeEventListener('userDataUpdated', handleUpdate);
    }, []);

    const value = {
        firebaseUser,
        userData,
        setUserData,
        refreshUserData,
        loading,
        isLoggedIn: !!firebaseUser || !!userData
    };

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
